// Centralized layout spacing tokens to keep spacing consistent across modules
// Update here to change spacing repo-wide where tokens are used.

export const CONTAINER_PY = 0;       // Vertical padding for page-level Container
export const HEADER_SPACER_MT = 2;    // Spacer under title: margin-top
export const HEADER_SPACER_MB = 1;    // Spacer under title: margin-bottom
export const FILTERS_PANEL_MB = 2.5;  // Bottom margin for filters panel

// Optional helpers for future consolidation
export const SECTION_PX = 3;          // Horizontal padding for inner sections
export const GRID_WRAPPER_PB = 3;     // Bottom padding for grid wrapper
export const HEADER_TOP_PT = 3;       // Top padding before title block inside cards
export const CONTROL_BAR_MB = 2;      // Bottom margin for top controls bar (create/pagination)
